import { useExtractColors } from "react-extract-colors";

/**
 * Контрастқа негізделіп, мәтін түсін қайтарады: қара, ақ немесе сұрғылт.
 */
export function useTextColorByImage(imageUrl) {
    const { dominantColor } = useExtractColors(imageUrl || "");

    const textColor = dominantColor ? getBestTextColor(dominantColor) : "#000000";

    return {
        textColor,
        isDark: isDarkColor(dominantColor)
    };
}

/**
 * RGB түсінің жарықтығын есептейді.
 */
function getLuminance(r, g, b) {
    const a = [r, g, b].map(v => {
        v = v / 255;
        return v <= 0.03928
            ? v / 12.92
            : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

/**
 * Екі түс арасындағы контрастты есептейді.
 */
function contrast(rgb1, rgb2) {
    const lum1 = getLuminance(rgb1[0], rgb1[1], rgb1[2]);
    const lum2 = getLuminance(rgb2[0], rgb2[1], rgb2[2]);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}

/**
 * Мәтінге ең жақсы контраст беретін түсті қайтарады.
 */
function getBestTextColor(hex) {
    if (!hex || hex[0] !== '#' || hex.length < 7) return "#000000";

    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    const white = [255, 255, 255];
    const black = [0, 0, 0];
    const background = [r, g, b];

    const contrastWithWhite = contrast(background, white);
    const contrastWithBlack = contrast(background, black);

    return contrastWithWhite > contrastWithBlack ? "#ffffff" : "#000000";
}

/**
 * Қараңғы түс пе – тек жарықтыққа қарап анықтайды.
 */
function isDarkColor(hex) {
    if (!hex || hex[0] !== '#' || hex.length < 7) return false;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
}